
<Layout>
    <template #title
        ><strong>{{ $t("manager.title") }}</strong></template
    >

    <template #nav> </template>

    <template #main>
        <b-row align-h="end">
            <b-col sm="2">
                <b-form-group
                    :label="$t('table.pagination.label')"
                    label-cols-sm="6"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="perPageSelect"
                    class="mb-0"
                >
                    <b-form-select
                        v-model="perPage"
                        id="perPageSelect"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>

            <b-col sm="5">
                <b-form-group
                    :label="$t('table.filter.label')"
                    label-cols-sm="2"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="filterInput"
                    class="mb-0"
                >
                    <b-input-group size="sm">
                        <b-form-input
                            v-model="filter"
                            :debounce="700"
                            type="search"
                            id="filterInput"
                            :placeholder="$t('table.filter.placeholder')"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button
                                :disabled="!filter"
                                @click="filter = ''"
                                variant="dark"
                                >{{ $t("table.filter.cancel") }}</b-button
                            >
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <b-table id="analysis-table" v-bind="settings">
            <template v-slot:head(ico)="data">
                {{ data.label | lower }}
            </template>

            <template v-slot:cell(index)="data">
                {{ data.index + 1 + (currentPage - 1) * perPage }}
            </template>

            <template v-slot:cell(hash)="data">
                <router-link
                    :to="{
                        name: 'teaser',
                        params: { hash: data.item.teaser_hash },
                    }"
                    class="btn btn-sm btn-outline-danger px-2 py-1 d-block my-2"
                >
                    Teaser
                </router-link>
                <router-link
                    v-if="data.item.version == 'lite'"
                    :to="{
                        name: 'lite',
                        params: { hash: data.item.lite_hash },
                    }"
                    class="btn btn-sm btn-danger px-2 py-1 d-block my-2"
                >
                    Lite
                </router-link>
                <router-link
                    v-if="data.item.version == 'full'"
                    :to="{
                        name: 'full',
                        params: { hash: data.item.full_hash },
                    }"
                    class="btn btn-sm btn-danger px-2 py-1 d-block my-2"
                >
                    Full
                </router-link>
                <button class="btn btn-sm btn-outline-danger px-2 py-1 d-block"
                    @click="generateHashes(data.item)" :disabled="generateHashesBusy"
                >
                    nové hashe
                </button>
            </template>

            <template v-slot:cell(created)="data">
                <div class="row small_text">
                    <div class="col">
                        modified:<br>
                        {{ data.item.modified }}
                    </div>
                </div>
                <div class="row small_text">
                    <div class="col">
                        created:<br>
                        {{ data.item.created }}
                    </div>
                </div>
                <div class="row small_text">
                    <div class="col">
                        origin_created:<br>
                        {{ data.item.origin_created }}
                    </div>
                </div>
            </template>

            <template v-slot:cell(period)="data">
                {{ data.item.start_date | moment("M/YYYY") }} -
                {{ data.item.end_date | moment("M/YYYY") }}
            </template>

            <template v-slot:cell()="data">
                {{ data.value }}
            </template>

            <template v-slot:table-busy>
                <Loader />
            </template>
        </b-table>

        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="action-stats-table"
        ></b-pagination>
    </template>
</Layout>
